var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66921 8.00012L0.275992 1.60679C-0.0919971 1.2388 -0.0919971 0.643992 0.275992 0.275997C0.643981 -0.0919989 1.23878 -0.0919989 1.60677 0.275997L7.99998 6.66933L14.3932 0.275997C14.7612 -0.0919989 15.356 -0.0919989 15.724 0.275997C16.092 0.643992 16.092 1.2388 15.724 1.60679L9.33079 8.00012L15.724 14.3935C16.092 14.7615 16.092 15.3563 15.724 15.7243C15.5405 15.9078 15.2996 16 15.0586 16C14.8177 16 14.5768 15.9078 14.3932 15.7243L8.00002 9.33092L1.6068 15.7243C1.42327 15.9078 1.18234 16 0.94141 16C0.70048 16 0.459549 15.9078 0.276024 15.7243C-0.0919666 15.3563 -0.0919666 14.7615 0.276024 14.3935L6.66921 8.00012Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/XMark.9230445f3351dd89f434bbd59e240395.svg";
export { ForwardRef as ReactComponent };